/**
 * 新しい検索条件の発行者候補が「0名で確定」した場合だけ、以前の選択を解除する。
 *
 * 読み込み中や取得失敗時の空配列は確定結果ではないため、選択を維持する。
 * 同じ関数を画面表示とstate更新の両方に使い、effect実行前の1描画だけ
 * 古い発行者名が残ることも防ぐ。
 * 本人IDの明示選択は、公開範囲付き候補APIが本人の週報を除外しても保持する。
 */
export const clearCreatorSelectionWhenResolvedEmpty = (
  selectedValues: string[],
  options: readonly unknown[] | null,
  optionsResolved: boolean,
  config?: { preserveSelectedUserId?: string | null }
): string[] => {
  if (!optionsResolved || options == null || options.length > 0) {
    return selectedValues;
  }
  const preservedUserId = String(config?.preserveSelectedUserId ?? '')
    .trim()
    .toLocaleLowerCase();
  if (preservedUserId) {
    const next = selectedValues.filter(
      (value) => value.trim().toLocaleLowerCase() === preservedUserId
    );
    return next.length === selectedValues.length ? selectedValues : next;
  }
  return selectedValues.length === 0 ? selectedValues : [];
};
